module.exports = __webpack_public_path__ + "img/2.5f66b3aa.png";